<header></header>
<div class="post-login-1">
    <div class="post-login-1-col-1 h-100">
        <left-panel activeTab="4" *ngIf="this.auth?.detailuser != undefined"></left-panel>
        <app-left-panel-prelogin activeTab="4" *ngIf="this.auth?.detailuser == undefined"></app-left-panel-prelogin>
    </div>
    <div class="post-login-1-col-2" *ngIf="this.FavouriteOffers">
        <div class="discover-box bg-8f8">
            <div class="link" (click)="back()">
                <ng-icon iconClass="icon-arrow-left-black" width="22" height="22"></ng-icon>
            </div>
            <div class="img-box mt-30 mt-ipad-0">
                <!-- <img src="../../assets/images/pasta-offer-img.png" alt=""> -->
                <img src="data:image/jpg;base64,{{this.FavouriteOffers.thumbnailBase64}}" style="height: 250px; background-size: 100%;" alt="">

                <!-- <div class="text-box">
                    <div class="font-600 font-size-20px line-h-32 color-base-100">
                        {{"BannerText" | translate }}
                    </div>
                    <grid-row class="mt-25">
                        <grid-col col="auto">
                            <ng-icon iconClass="icon-heart-white" width="18" height="22"></ng-icon>
                            <span class="font-500 font-size-12px line-h-18 color-base-100 ml-5">
                                2356
                            </span>
                        </grid-col>
                    </grid-row>
                </div> -->
            </div>
            <grid-row class="justify-content-between align-item-center mt-40">
                <grid-col col="auto">
                    <div class="font-600 font-size-14px line-h-20 color-base-1200">
                        {{this.FavouriteOffers.title}}
                    </div>
                    <div class="font-700 font-size-32px line-h-40 color-base-700 mt-10">
                        {{this.FavouriteOffers.caption}}
                    </div>
                    <div class="mt-15">
                        <ng-icon iconClass="icon-heart-black" width="18" height="25"></ng-icon>
                    </div>
                    <div class="font-400 font-size-14px line-h-20 color-base-600 mt-40">
                        <!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam ac dolor fermentum, tristique tortor nec, posuere orci.
                        Pellentesque pharetra finibus lorem, a volutpat ex sollicitudin quis. Phasellus at libero felis. Fusce a rhoncus lorem,
                        id mattis purus. Aenean a turpis dapibus, mattis velit vitae, tempor libero. -->

                        {{this.FavouriteOffers.description}}

                    </div>
                    <div class="font-400 font-size-14px line-h-20 color-base-600 mt-30">
                        {{"PromotionPeriod:" | translate}}
                    </div>
                    <div class="font-400 font-size-14px line-h-20 color-base-600">
                        <!-- 14 Aug 2023 - 21 Dec 2023 --> {{this.FavouriteOffers.startDate | date:"dd MMM YYYY"}} -
                        {{this.FavouriteOffers.endDate | date:"dd MMM YYYY"}}

                    </div>
                    <div class="mt-40">
                        <a href="{{this.FavouriteOffers.merchantFacebook}}" target="_blank" *ngIf="this.FavouriteOffers.merchantFacebook != ''" > <ng-icon
                                iconClass="icon-facbook-black bg-nuetral-primary br-8 mr-16" width="40"
                                height="40"></ng-icon>
                        </a>
                        <a href="{{this.FavouriteOffers.merchantInstaLink}}" target="_blank" *ngIf="this.FavouriteOffers.merchantInstaLink != ''"> <ng-icon
                                iconClass="icon-insta-black bg-nuetral-primary br-8 mr-16" width="40"
                                height="40"></ng-icon>
                        </a>
                    </div>
                    <div class="font-400 font-size-14px line-h-20 color-base-600 mt-30 text-uppercase" *ngIf="this.FavouriteOffers.branches.length > 0">
                        {{"Branches" | translate}}
                    </div>
                    <div col="3" *ngFor="let b of this.FavouriteOffers.branches">
                        <div col="3"> <span>{{b.area}}</span> <span>{{b.branchName}}</span>
                        </div>
                    </div>
                </grid-col>
            </grid-row>
        </div>
        <div class="discover-box bg-nuetral-primary">
            <grid-row class="col-space-min">
                <grid-col col="12">
                    <grid-row class="justify-content-between align-item-center mb-20">
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-base-1200">
                                {{ "YOUMIGHTLIKE" | translate }}
                            </div>
                        </grid-col>
                    </grid-row>
                </grid-col>
                <grid-col col="12">
                    <div class="carousel-wrapper mt-10">
                        <owl-carousel-o [options]="carouselOptions">
                            <ng-template carouselSlide *ngFor="let item of this.offerSlider">
                                 <div class="deal-card" >
                                    <div class="card-img">
                                        <img src="data:image/jpg;base64,{{item.thumbnailBase64}}" alt="">
                                    </div>
                                    <div class="content-box">
                                        <div class="font-600 font-size-10px color-base-800 line-h-12 letter-spacing-1 text-uppercase mt-14">
                                            {{item.title}}
                                        </div>
                                        <div class="font-400 font-size-10px color-base-2800 letter-spacing-2 line-h-20 mt-10">
                                            {{item.caption}}
                                        </div>
                                        <grid-row class="mt-30 align-item-center">
                                            <grid-col col="auto">
                                                <!-- <wishlist (returnClick)="heartIcon(item.id)" [itemStatus]="item.heart" *ngIf="this.auth?.detailuser"></wishlist> -->
                                                <ng-icon iconClass="icon-heart-active"   *ngIf="this.auth?.detailuser != undefined && item.heart == true " width="18" height="25"></ng-icon>

                                                <ng-icon iconClass="icon-heart-black"  *ngIf="this.auth?.detailuser != undefined && item.heart == false" width="18" height="25"></ng-icon>
                                            </grid-col>
                                            <grid-col col="auto">
                                                <!-- <span class="font-500 font-size-12px line-h-18 letter-spacing-1 ml-5">
                                                    2356
                                                </span> -->
                                            </grid-col>
                                        </grid-row>
                                    </div>
                                </div>
                            </ng-template>
                        </owl-carousel-o>
                    </div>
                </grid-col>
                <!-- <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6">
                    <div class="deal-card">
                        <div class="card-img">
                            <img src="~/../assets/images/eat-pasta-img.png" alt="">
                        </div>
                        <div class="content-box">
                            <div
                                class="font-600 font-size-10px color-base-800 line-h-12 letter-spacing-1 text-uppercase mt-14">
                                {{"EatPasta" | translate }}
                            </div>
                            <div class="font-400 font-size-14px color-base-2800 letter-spacing-2 line-h-20 mt-10">
                                {{"GetOffOnBill" | translate }}
                            </div>
                            <grid-row class="mt-50 align-item-center">
                                <grid-col col="auto">
                                    <ng-icon iconClass="icon-heart-black" width="18" height="25"></ng-icon>
                                </grid-col>
                                <grid-col col="auto">
                                    <span class="font-500 font-size-12px line-h-18 letter-spacing-1 ml-5">
                                        2356
                                    </span>
                                </grid-col>
                            </grid-row>
                        </div>
                    </div>
                </grid-col>
                <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6">
                    <div class="deal-card">
                        <div class="card-img">
                            <img src="../../assets/images/airport-hotel-img.png" alt="">
                        </div>
                        <div class="content-box">
                            <div
                                class="font-600 font-size-10px color-base-800 line-h-12 letter-spacing-1 text-uppercase mt-14">
                                {{"bahrainAirportHotel" | translate }}
                            </div>
                            <div class="font-400 font-size-14px color-base-2800 letter-spacing-2 line-h-20 mt-10">
                                {{"GetOffOnBill" | translate }}
                            </div>
                            <grid-row class="mt-50 align-item-center">
                                <grid-col col="auto">
                                    <ng-icon iconClass="icon-heart-black" width="18" height="25"></ng-icon>
                                </grid-col>
                                <grid-col col="auto">
                                    <span class="font-500 font-size-12px line-h-18 letter-spacing-1 ml-5">
                                        2356
                                    </span>
                                </grid-col>
                            </grid-row>
                        </div>
                    </div>
                </grid-col>
                <grid-col col="4" class="mt-ipad-15" mobile="12" ipad="6">
                    <div class="deal-card">
                        <div class="card-img">
                            <img src="~/../assets/images/flura-img.png" alt="">
                        </div>
                        <div class="content-box">
                            <div
                                class="font-600 font-size-10px color-base-800 line-h-12 letter-spacing-1 text-uppercase mt-14">
                                {{"FURLA" | translate }}
                            </div>
                            <div class="font-400 font-size-14px color-base-2800 letter-spacing-2 line-h-20  mt-10">
                                {{"GetOffOnBill" | translate }}
                            </div>
                            <grid-row class="mt-50 align-item-center">
                                <grid-col col="auto">
                                    <ng-icon iconClass="icon-heart-black" width="18" height="25"></ng-icon>
                                </grid-col>
                                <grid-col col="auto">
                                    <span class="font-500 font-size-12px line-h-18 letter-spacing-1 ml-5">
                                        2356
                                    </span>
                                </grid-col>
                            </grid-row>
                        </div>
                    </div>
                </grid-col> -->
            </grid-row>
        </div>
    </div>
    
    <!-- <div class="post-login-1-col-3">
        <div class="pl-20 pr-20">
            <div class="font-400 font-size-14px line-h-20 color-base-1500 mt-14 letter-spacing-1 mb-10">
                {{"Sponsored" | translate }}
            </div>
            <div class="deal-card pt-10 pb-10">
                <div class="card-img">
                    <img src="~/../assets/images/heath-coverage-img.jpg" alt="">
                </div>
                <div class="content-box bg-2900">
                    <div class="font-600 font-size-14px line-h-20 color-base-1500">
                        {{"NeedMedicalInsurance" | translate }}
                    </div>
                    <div class="font-400 font-size-14px line-h-20 color-base-600 mt-8">
                        {{"GetYourFamilyMedical" | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>